<script>
    import { onMount } from 'svelte';

    const RADIUS = 40
    const MID_X = 50
    const MID_Y = 50
    const MIN_RADIANS = (4 * Math.PI) / 3
    const MAX_RADIANS = -Math.PI / 3
    
    // map a value (x) from one range (in min/max) onto another (out min/max)
    const mapRange = (x, inMin, inMax, outMin, outMax) => {
      return ((x - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin
    }
    
    export let animation = {
        animated: false,
        animateValue: false,
        animationDuration: 2000,
        animationFunction: 'ease-in-out',
    };
    export let value;
    export let max = 100;
    export let min = 0;
    export let disabled = false;
    export let size = 100;
    export let responsive = false;
    export let primaryColor = '#409eff';
    export let secondaryColor = '#dcdfe6';
    export let textColor = '#000000';
    export let strokeWidth = 17;
    export let valueDisplayFunction = (v) => v;

    let length = 0;
    let animatedValue = 0;
    let interval = null
    let pathElement;

    $: dashStyle = { strokeDasharray: length, strokeDashoffset: length }; 
    $: style = { height: responsive ? size + '%' : size - 5 + 'px' };
    $: computedSize = responsive ? size + '%' : size;
    $: rangePath = `M ${minX} ${minY} A ${RADIUS} ${RADIUS} 0 1 1 ${maxX} ${maxY}`;
    $: valuePath = `M ${zeroX} ${zeroY} A ${RADIUS} ${RADIUS} 0 ${largeArc} ${sweep} ${valueX} ${valueY}`;
    $: showValue = value >= min && value <= max && !disabled;
    $: zeroRadians = (min > 0 && max > 0) ? mapRange(min, min, max, MIN_RADIANS, MAX_RADIANS) : mapRange(0, min, max, MIN_RADIANS, MAX_RADIANS);
    $: valueRadians = mapRange(value, min, max, MIN_RADIANS, MAX_RADIANS);
    $: minX = MID_X + Math.cos(MIN_RADIANS) * RADIUS;
    $: minY = MID_Y - Math.sin(MIN_RADIANS) * RADIUS;
    $: maxX = MID_X + Math.cos(MAX_RADIANS) * RADIUS;
    $: maxY = MID_Y - Math.sin(MAX_RADIANS) * RADIUS;
    $: zeroX = MID_X + Math.cos(zeroRadians) * RADIUS;
    $: zeroY = MID_Y - Math.sin(zeroRadians) * RADIUS;
    $: valueX = MID_X + Math.cos(valueRadians) * RADIUS;
    $: valueY = MID_Y - Math.sin(valueRadians) * RADIUS;
    $: largeArc = Math.abs(zeroRadians - valueRadians) < Math.PI ? 0 : 1;
    $: sweep = valueRadians > zeroRadians ? 0 : 1;
    $: valueDisplay = valueDisplayFunction(animation.animateValue ? animatedValue : value);
 
    onMount(async () => {
        dashLength(); // the element should be in the DOM
    
        clearInterval(interval);
        interval = null;
    
        if (animation.animateValue) {
            interval = setInterval(() => {
                if (animatedValue < value) {
                    animatedValue += 1
                } else {
                    clearInterval(interval)
                    interval = null
                }
            }, (animation.animationDuration * 1000) / value / 1000)
        }
    });

    let dashLength = () => {
        const elementLength = pathElement.getTotalLength();

        if (animation.animated) {
            pathElement.style.animationDuration =
                animation.animationDuration / 1000 + 's'
                pathElement.style.animationFunction = animation.animationFunction
        }

        pathElement.dataset.dash = elementLength

        length = elementLength
    };
</script>

<div class="knob-control" style="{style}">
    <svg
        width="{computedSize}"
        height="{computedSize}"
        viewBox="0 0 100 100"
    >
        <path
            d="{rangePath}"
            stroke-width="{strokeWidth}"
            stroke="{secondaryColor}"
            class="knob-control__range"
        />
        
            <path
                bind:this="{pathElement}"
                d="{valuePath}"
                stroke-width="{strokeWidth}"
                stroke="{primaryColor}"
                data-dash="{length}"
                style="stroke-dasharray: {length}px; stroke-dashoffset: {length}px;"
                class="knob-control__value"
            />
            <text
                x="50"
                y="57"
                text-anchor="middle"
                fill="{textColor}"
                class="knob-control__text-display"
            >
                {valueDisplay}
            </text>
        
    </svg>
</div>
  
<style>
    @keyframes dash-frame {
        100% {
            stroke-dashoffset: 0;
        }
    }

    .knob-control__range {
        fill: none;
        transition: stroke 0.1s ease-in;
    }

    .knob-control__value {
        animation-name: dash-frame;
        animation-fill-mode: forwards;
        fill: none;
    }

    .knob-control__text-display {
        font-size: 1.3rem;
        text-align: center;
    }
</style>
  